import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from '../../hooks/useApi';
import { useSession } from '../../session/SessionContext';
import { Card, Field } from '../../components/ui';
import { InlineError } from '../../components/ErrorView';
import { routes } from '../../api/routes';

export function Signup() {
  const nav = useNavigate();
  const { refresh } = useSession();
  const [form, setForm] = useState({ email: '', password: '', handle: '', country: '' });
  const signup = useMutation<Record<string, unknown>, unknown>(routes.auth.signup);

  const set = (k: keyof typeof form, v: string) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await signup.run(form);
    if (!res) return;
    await refresh();
    nav('/verify', { state: { email: form.email } });
  };

  return (
    <div className="narrow">
      <Card title="Create an account">
        <form onSubmit={submit}>
          <Field id="su-email" label="Email">
            <input
              id="su-email"
              className="input"
              type="email"
              autoComplete="email"
              required
              value={form.email}
              onChange={(e) => set('email', e.target.value)}
            />
          </Field>
          <Field
            id="su-handle"
            label="Handle"
            hint="Lowercase letters, digits and underscores. 3–30 characters."
          >
            <input
              id="su-handle"
              className="input"
              pattern="[a-z0-9_]{3,30}"
              required
              value={form.handle}
              onChange={(e) => set('handle', e.target.value)}
            />
          </Field>
          <Field id="su-password" label="Password" hint="At least 12 characters.">
            <input
              id="su-password"
              className="input"
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
              value={form.password}
              onChange={(e) => set('password', e.target.value)}
            />
          </Field>
          <Field id="su-country" label="Country" hint="Two-letter code, e.g. GB.">
            <input
              id="su-country"
              className="input input-narrow"
              maxLength={2}
              required
              value={form.country}
              onChange={(e) => set('country', e.target.value.toUpperCase())}
            />
          </Field>
          {signup.problem ? <InlineError problem={signup.problem} /> : null}
          <button type="submit" className="btn btn-primary" disabled={signup.pending}>
            {signup.pending ? 'Creating…' : 'Create account'}
          </button>
        </form>
        <p className="muted">
          Already have one? <Link to="/login">Sign in</Link>.
        </p>
      </Card>
    </div>
  );
}
